module.exports = __webpack_public_path__ + "static/media/notification.00ba96d1.mp3";